import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M44.9006 3.24023L3.8125 17.4299L14.1408 28.0002V43.0002L22.1408 35.7872L30.6964 44.3428L44.9006 3.24023Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.1406 27.9961L32.1406 15.9961",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }